import React from "react";
import { translate } from "../../Services/translation";
import InputField from "./InputField";

function ExternalDocumentNumber({ control }) {
    const name = "externalDocumentNumber";

    return (

        <div>
            <>
                <p className="checkout__section-title">{translate('checkout.form.otherinformation')}</p>
                <div className="card">
                    <div className="card__body card__body--large">
                        <div className="checkout__form-container">

                            <div>
                                <p className="checkout__label">{translate('checkout.form.externaldocumentnumber.label')}</p>

                                <InputField
                                    name={name}
                                    placeholder={translate('checkout.form.externaldocumentnumber.placeholder')}
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <p className="checkout__customs-text">{translate('checkout.customs.text')}</p>
            </>
        </div>
    );
}

export default ExternalDocumentNumber;
